import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a5e621dc")

_pushScopeId("data-v-a5e621dc")
const _hoisted_1 = { class: "uiTitle" }
const _hoisted_2 = { class: "header flex justify-between" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.hasShow)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "right",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShow = !_ctx.isShow))
          }, "收起"))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "body")
    ], 512), [
      [_vShow, _ctx.isShow]
    ])
  ]))
})